import { render, staticRenderFns } from "./Huifu.vue?vue&type=template&id=85ddd730&scoped=true&"
import script from "./Huifu.vue?vue&type=script&lang=js&"
export * from "./Huifu.vue?vue&type=script&lang=js&"
import style0 from "./Huifu.vue?vue&type=style&index=0&id=85ddd730&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85ddd730",
  null
  
)

export default component.exports